export const getInitialState = (): any => ({
  modelAddingStatusData: {}
});
